import * as React from 'react';
import { useContext } from 'react';

import { Text } from '@shared/components/bootstrap';
import { InventoryContext } from '@shared/components/inventory_capture/inventory_context';
import { Picker as PackingCategorySelectionPicker } from '@shared/components/packing_category_selection/picker';

export const PackingCategories: React.FC<{ pickup?: boolean }> = ({ pickup = true }) => {
  const { data, onSelect } = useContext(InventoryContext);

  return (
    <>
      <Text tag="p" style="info">
        <strong>{pickup ? 'What needs to be packed up?' : 'Do your items fall into any of these categories?'}</strong>
      </Text>

      <PackingCategorySelectionPicker
        selections={data.packableEstimations}
        onChange={(packableEstimations) => onSelect({ ...data, packableEstimations })}
        onNextClick={() => onSelect({ ...data, packingCategoriesComplete: true })}
        complete={!!data.packingCategoriesComplete}
      />
    </>
  );
};
